// JsFromRoutes CacheKey 9ebe6b6a4e397d00abc5b7fd8041baa1
//
// DO NOT MODIFY: This file was automatically generated by JsFromRoutes.
import { definePathHelper } from 'utils/js_from_routes_client'

export default {
  index: /* #__PURE__ */ definePathHelper('get', '/admin/medical_plan_data_jobs'),
}
